export const config = {
  i18n: {
    locales: {
      en: {
        currency: "USD",
        label: "English",
      },
      pt: {
        currency: "BRL",
        label: "Português Brasil",
      },
    },
    defaultLocale: "pt",
    defaultCurrency: "BRL",
    localeCookieName: "NEXT_LOCALE",
  },
  teams: {
    avatarColors: ["#4e6df5", "#e5a158", "#9dbee5", "#ced3d9"],
  },
  auth: {
    redirectAfterLogout: "/",
    sessionCookieName: "auth_session",
    sessionCookieMaxAge: 60 * 60 * 24 * 30,
  },
  mailing: {
    provider: "postmark",
    from: "no-reply@click.autos",
  },
  ui: {
    enabledThemes: ["light", "dark"],
    defaultTheme: "light",
  },
} as const satisfies Config;

export type Config = {
  i18n: {
    locales: { [locale: string]: { currency: string; label: string } };
    defaultLocale: string;
    defaultCurrency: string;
    localeCookieName: string;
  };
  teams: { avatarColors: string[] };
  auth: {
    redirectAfterLogout: string;
    sessionCookieName: string;
    sessionCookieMaxAge: number;
  };
  mailing: {
    provider:
      | "custom"
      | "console"
      | "plunk"
      | "resend"
      | "postmark"
      | "nodemailer";
    from: string;
  };
  ui: {
    enabledThemes: Array<"light" | "dark">;
    defaultTheme: Config["ui"]["enabledThemes"][number];
  };
};

export type Locale = keyof (typeof config)["i18n"]["locales"];
